<tabs-inner-wrap>
  <ng-container *ngIf="!isLoading; else loadingTemplate">
    <details-section [title]="hasAssignees ? ('simulationBuilder.SEARCH_ASSIGNEES_TITLE' | transloco) : ''" [showDetails]="false" [class.no-data]="!hasAssignees">
      <div class="container">
        @if (hasAssignees) {
          <div class="assignees-content">
            <qai-field class="search-field" label="">
              <qai-icon kind="search" qaiSlot="startIcon" />
              <input qai-input type="text" [(ngModel)]="searchTerm" />
            </qai-field>

            <button
              qai-button
              [shape]="'normal'"
              [kind]="'tertiary'"
              [size]="'medium'"
              [disabled]="isCompleted || simulationsCount == 0"
              (click)="handleAddUserToAssignmentClick()"
            >
              {{ 'simulationBuilder.ADD_USERS_TO_ASSIGNMENT' | transloco }}
            </button>
          </div>
        }

        @if (!hasAssignees) {
          <qai-table
            [headers]="headers"
            [data]="[]"
            [striped]="false"
            (ctaClicked)="handleAddUserToAssignmentClick()"
            [noDataMessage]="'simulationBuilder.ASSIGNEES_ZERO_STATE_MESSAGE' | transloco"
            [showCta]="true"
            [ctaText]="'simulationBuilder.ADD_USERS_TO_ASSIGNMENT' | transloco"
            [noDataMessageStyle]="noDataMessageStyle"
          ></qai-table>
        }

        @if (hasAssignees) {
          <div class="table-wrapper" [class.completed-assignment]="isCompleted">
            <ng-container *ngIf="displayedTableData.length > 0; else noData">
              <qai-table
                [headers]="headers"
                [data]="displayedTableData"
                [striped]="false"
                (rowAction)="onTableRowAction($event)"
                [initialSortColumn]="initialSortColumn"
                [initialSortDirection]="initialSortDirection"
                [previousLabel]="'simulationBuilder.PAGINATION_PREVIOUS' | transloco"
                [nextLabel]="'simulationBuilder.PAGINATION_NEXT' | transloco"
              ></qai-table>
            </ng-container>

            <ng-template #noData>
              <div class="no-data-container">
                <span>{{ 'simulationBuilder.NO_DATA_FOUND' | transloco }}</span>
              </div>
            </ng-template>
          </div>
        }
      </div>
    </details-section>
  </ng-container>

  <ng-template #loadingTemplate>
    <div class="loading-container">
      <qai-loading [size]="'medium'"></qai-loading>
    </div>
  </ng-template>
</tabs-inner-wrap>

<add-users-to-assignment-modal
  [open]="assignmentModalVisible"
  [moduleAssignmentUuid]="moduleAssignmentUuid"
  (closeModal)="closeAssignmentModal()"
  [networkRequestInProgress]="networkRequestInProgress"
  (addToAssignmentClicked)="addToAssignment()"
  [currentAssignees]="currentAssigneesList"
  [isCreateAssignmentFlow]="false"
></add-users-to-assignment-modal>
